var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12253 5.09669C7.67991 5.09669 6.95744 6.84088 7.97753 7.86097C8.2812 8.16464 8.4518 8.57651 8.4518 9.00597L8.4518 10.9031C8.4518 11.3325 8.2812 11.7444 7.97752 12.0481C6.95743 13.0682 7.6799 14.8124 9.12252 14.8124L11.9041 14.8124L11.9041 19.6893C11.9041 20.0184 12.1709 20.2852 12.5 20.2852C12.8291 20.2852 13.096 20.0184 13.096 19.6893L13.096 14.8124L15.8775 14.8124C17.3201 14.8124 18.0426 13.0682 17.0225 12.0481C16.7188 11.7444 16.5482 11.3325 16.5482 10.9031L16.5482 9.00596C16.5482 8.57651 16.7188 8.16464 17.0225 7.86096C18.0426 6.84087 17.3201 5.09668 15.8775 5.09668L9.12253 5.09669Z",
    fill: "#0C002C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8945,
    y: 5.69043,
    width: 1.6,
    height: 18,
    rx: 0.8,
    transform: "rotate(60 19.8945 5.69043)",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDeleteIcon);
export default __webpack_public_path__ + "static/media/pinDeleteIcon.82ab19b434dce0b0be4f72e79d6d1996.svg";
export { ForwardRef as ReactComponent };